<template>
  <div class="page flex-col">
    <van-nav-bar
      title="设备绑定"
      left-text="返回"
      left-arrow
      @click-left="$router.go('-1')"
    />

    <div class="" >
      <div class="flex box-1  flex-row" style="text-align: left;justify-content:center;">
        <div style="display:block;">
            <img src="../../assets/img/device-back.png" style="height: 4rem;width:2.2rem" />
        </div>
        <div style="margin-left:15px; margin-top: 30px; ">
          <label class="title_1">扫描或输入设备号</label>
          <label class="title_2">打开学生证面板</label>
          <label class="title_2">在下方输入框输入</label>
          <label class="title_2">或扫描设备号</label>
         
        </div>
      </div>
     
      
      
      <div class="" style="position:absolute; width:100%">
        <div  style="display: flex; justify-content:center;align-items: center;color:#0070ff;margin-top: 10px;">姓名：{{studentname}}</div>

        <div class=" box-2 flex-row " style="justify-content:center;align-items: center;">
          <input placeholder="输入设备号" v-model="deviceid"  class="device-input" />
          <img
            class=""
            style="padding: 10 10 10 10px;"
            src="../../assets/img/scan.png"
            @click="getQRBarcode"
          />
        </div>
      
      <div style="margin: 50px;">
        <van-button round block type="info" native-type="submit" @click="bindDevice">绑  定</van-button>
      </div>
      <div style="margin: 50px;">
        <van-button round block type="default" native-type="submit" @click="ignorejump">跳  过</van-button>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import { Button, Toast } from 'vant'
import wx from 'weixin-jsapi'
export default {
  data() {
    return {
      studentname:"",
      deviceid:"",
      constants: {}
    };
  },
  created:function(){
   
    wx.ready(function(){
      //alert("ready")
      wx.checkJsApi({
            jsApiList: ['scanQRCode'],
            success: function (res) {
              //alert(JSON.stringify(res));
             
            }
       })
    });
    wx.error(function(res){
      //alert("error:" + res.errMsg);
     // alert(JSON.stringify(res));
    });

    this.studentname=this.$route.query.studentname;
    this.getWXConfig();
  },
  methods: {
    ignorejump:function(){
      //this.$router.push('/home');
      this.$router.push({name:"my",query:{studentid:this.$route.query.studentid}});
    },
    //条码扫描
    getQRBarcode:function(){
      var that = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        desc: 'scanQRCode desc',
        scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
         // alert("ok12");
          setTimeout(()=>{
            that.deviceid=res.resultStr;
          },10);
         
        },
        complete:function(){
          //alert("complete");
        },
        error:function(err){
          //alert("error")
        },
        fail:function(err){
          //alert("fail")
        }
      });
    },
    //得到微信config信息
    getWXConfig:function(){
      // alert(window.entryUrl)
      this.$http
          .json_post("/api/GetWXJSTicket",{
            url: window.entryUrl
          }).then(data=>{
            if(data.code==0){
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: data.data.appid, // 必填，公众号的唯一标识
                    timestamp: data.data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
                    signature: data.data.sign,// 必填，签名
                    jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表
                });
            }else {
              Toast(data.msg);
            }
          })
      
    },
    bindDevice:function(){
      if(this.deviceid==""){
        Toast("请输入设备码");
        return;
      }
      if(this.$route.query.studentid==""){
        Toast("没有选定学生");
        return;
      }
      this.$http
          .json_post(this.$api.studentcard.binddevice, {
            Studentid : eval(this.$route.query.studentid),
            Deviceid : this.deviceid
          })
          .then(data => {
            console.log("data",data);
            if (data.code===0){
              Toast("绑定成功");
              this.$router.push({name:"my",query:{studentid:this.$route.query.studentid}});
            }else {
              Toast.fail(data.msg);
            }
          })
    }
  },
  components:{
    'van-button':Button
  }
};
</script>
<style lang="scss"  scoped>
    .box-1 {
       // margin:20px 20px 20px 20px;
        //width:80%;
        margin-top:50px;
        height: 180px;
       
        text-align:center;
    }
    .box-2 {
        display: flex;
       
        margin-top:50px;
      
        width: 100%;
        height: 30px;
        position: relative;
        text-align:center;
    }
    
    .device-input {
        font-size: 0.4rem; 
        line-height: 46px;
        border-style: none;
        border:transparent;
        height: 50px;
        width:70%;
        border-radius: 15px;
    }
    .device-scan {

    }
    .title_1 {
        color:#0070FF;
        
        font-weight:bold;
        display: block;
    }
    .title_2 {
        padding-top:10px;
        display: block;
    }

</style>